module.exports = __webpack_public_path__ + "media/top-bg-video.e5359d3b.mp4";